import { QUERY_KEYS } from "library/shared";
import { IBenefitCategory } from "library/types";
import { UseQueryResult, useQuery, useQueryClient } from "react-query";
import api from "service/api";

type Params = {
  countryCode: number | string | null;
  clientInternalNumberGOS: number | string;
  benefitCategoryTag: number | string;
  enabled?: boolean;
};

const getBenefitCategory = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
}: Params) => {
  if (
    countryCode === null ||
    clientInternalNumberGOS === null ||
    benefitCategoryTag === null
  )
    return;

  const response = await api.get(
    `/benefitcategory/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}`
  );

  return response.data;
};

export function useGetBenefitCategory({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
  enabled = true,
}: Params): UseQueryResult<IBenefitCategory> {
  return useQuery<IBenefitCategory, Error>(
    [QUERY_KEYS.benefitCategory, countryCode, clientInternalNumberGOS],
    () =>
      getBenefitCategory({
        countryCode,
        clientInternalNumberGOS,
        benefitCategoryTag,
      }),
    {
      enabled: enabled,
      staleTime: 0,
      refetchOnMount: true,
      //   onError: (error: any) => {
      //     errorHandler({
      //       label: "Error",
      //       type: notificationTypes.error,
      //       value: "Error while loading offer item data",
      //       errors: error?.message,
      //       fieldName: "",
      //     });
      //   },
    }
  );
}

export const useInvalidateBenefitCategory = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.benefitCategory });
};
export const useRefetchBenefitCategory = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.refetchQueries({ queryKey: QUERY_KEYS.benefitCategory });
};
